import Sod from './Sod';

export default Sod;
